var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg824",
    width: 33.279999,
    height: 30.08,
    viewBox: "0 0 33.279999 30.08",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs828"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer6",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.240925,21.929757 31.448902,1.8110808 H 1.810939 l 9.45706,15.3597642 M 6.1123512,8.6947184 25.836612,8.7816835",
    stroke: "#cc214f",
    strokeWidth: 4.11788,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path948-5-9-7",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#806000",
      strokeWidth: 3.62216,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.600724,25.515392 c 0,-2.502818 2.031752,-4.531852 4.537923,-4.531852 2.50617,0 4.537923,2.029034 4.537923,4.531852 0,2.502818 -2.031753,4.531852 -4.537923,4.531852 -2.506171,0 -4.537923,-2.029034 -4.537923,-4.531852 z m 5.871797,0 c 0,-0.73567 -0.597219,-1.332089 -1.333874,-1.332089 -0.736657,0 -1.333873,0.596419 -1.333873,1.332089 0,0.735671 0.597216,1.33209 1.333873,1.33209 0.736655,0 1.333874,-0.596419 1.333874,-1.33209 z",
    fill: "#0f2426",
    id: "path950-4-8-7",
    style: {
      display: "inline",
      fill: "#806000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.137421,
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.addacae77f301e5ef1f15d61ea1fb2e3.svg";
export { ForwardRef as ReactComponent };